'use client';

import { type ReactNode } from 'react';
import { Box } from '@terra/ui-styled-system';
import { isPlainRecord } from '@terra/shared-dto-chat-types';
import { MetaDefault } from '../../../../../components/typography';
import type { CardRenderContext } from '../../tool-config-types';
import { renderHttpCard } from '../http/http-card-renderer';
import {
  dispatchPortalToolNavigate,
  getPortalToolDisplayConfig,
} from './portal-tool-display-config';
import { REPLAY_REQUEST_TOOL_NAME } from '@terra/shared-dto-chat-types';

function unwrapPortalToolResponseData(output: unknown): unknown {
  if (!isPlainRecord(output) || !isPlainRecord(output.data)) {
    return output;
  }

  return output.data;
}

export function renderReplayRequestCard(ctx: CardRenderContext): ReactNode {
  const displayConfig = getPortalToolDisplayConfig(REPLAY_REQUEST_TOOL_NAME);
  const navigation = displayConfig?.getNavigation(ctx.toolCallData.output);

  return (
    <Box width="100%">
      {renderHttpCard({
        ...ctx,
        toolCallData: {
          ...ctx.toolCallData,
          output: unwrapPortalToolResponseData(ctx.toolCallData.output),
        },
      })}
      {navigation?.label && (
        <MetaDefault
          as="button"
          color="colorPalette.default"
          mt={2}
          cursor="pointer"
          onClick={() => {
            dispatchPortalToolNavigate(navigation);
          }}
        >
          {navigation.label}
        </MetaDefault>
      )}
    </Box>
  );
}
